import { render, staticRenderFns } from "./DissociateClientToAssetDialogComponent.vue?vue&type=template&id=2faa9d08&"
import script from "./DissociateClientToAssetDialogComponent.vue?vue&type=script&lang=js&"
export * from "./DissociateClientToAssetDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports